import { z } from 'zod'
import { responseSchema } from '@/core/types/Response.ts'

const originCertificateVehicleSchema = z.object({
  plateNumber: z.string().nullable(),
  bodySerial: z.string().nullable(),
  chassisSerial: z.string().nullable(),
  vin: z.string().nullable(),
  engineSerial: z.string().nullable(),
  brand: z.string().nullable(),
  model: z.string().nullable(),
  modelYear: z.number().nullable(),
  year: z.number().nullable(),
  vehicleClass: z.string().nullable(),
  type: z.string().nullable(),
  use: z.string().nullable(),
  service: z.string().nullable(),
  primaryColor: z.string().nullable(),
  secondaryColor: z.string().nullable(),
  seats: z.number().nullable(),
  axes: z.number().nullable(),
  taraKg: z.number().nullable(),
  loadCapacityKg: z.number().nullable(),
  originCertificateNumber: z.string().nullable(),
  originCertificateDate: z.string().nullable()
})

const originCertificateCertificateSchema = z.object({
  controlNumber: z.string().nullable(),
  companyName: z.string().nullable(),
  emissionDate: z.string().nullable(),
  entryPort: z.string().nullable(),
  invoiceNumber: z.string().nullable(),
  invoiceDate: z.string().nullable(),
  invoice3Number: z.string().nullable(),
  invoice3Date: z.string().nullable(),
  taxSheetNumber: z.string().nullable(),
  taxSheetDate: z.string().nullable(),
  acquisitionInvoiceNumber: z.string().nullable(),
  acquisitionDate: z.string().nullable(),
  refeciv: z.string().nullable(),
  agreementEndDate: z.string().nullable(),
  buyerDocument: z.string().nullable(),
  buyerName: z.string().nullable(),
  buyerHouseNumber: z.string().nullable(),
  buyerUrbanization: z.string().nullable(),
  buyerMunicipality: z.string().nullable(),
  buyerAddress: z.string().nullable(),
  buyerCity: z.string().nullable(),
  buyerPostalCode: z.string().nullable(),
  buyerFederalEntity: z.string().nullable(),
  insuranceCompany: z.string().nullable(),
  insurancePolicyExpiry: z.string().nullable(),
  reservationFavor: z.string().nullable(),
  reservationDocument: z.string().nullable()
})

const originCertificateDataSchema = z.object({
  vehicle: originCertificateVehicleSchema,
  certificate: originCertificateCertificateSchema
})

export const originCertificateResponseSchema = responseSchema(
  originCertificateDataSchema
)

export type OriginCertificateResponse = z.infer<
  typeof originCertificateResponseSchema
>
